import { IHomeState } from './types';
import {
  Actions,
  GET_USER_FAVORITE_PROJECTS,
  GET_USER_FAVORITE_PROJECTS_SUCCEEDED,
  GET_USER_FAVORITE_BENCHMARK_REPORTS_SUCCEEDED,
  GET_USER_METRICS,
  GET_USER_METRICS_SUCCEEDED,
  CLEAR_HOME_STATE,
} from './actions';

const initialState: IHomeState = {
  loadingProjects: true,
  loadingMetrics: true,
  userFavoriteProjectsByType: {
    existing_site_analysis: [],
    programming: [],
  },
  favoriteBenchmarkReports: [],
  userMetrics: {
    projects: {
      joined: null,
      pending: null,
      all: null,
    },
    teams: {
      joined: null,
      pending: null,
    },
    reports: {
      unverified: null,
      total: null,
    },
  },
};

const reducer = (
  state: IHomeState = initialState,
  action: Actions
): IHomeState => {
  switch (action.type) {
    case GET_USER_FAVORITE_PROJECTS:
      return {
        ...state,
        loadingProjects: true,
      };
    case GET_USER_FAVORITE_PROJECTS_SUCCEEDED: {
      return {
        ...state,
        userFavoriteProjectsByType: action.payload,
        loadingProjects: false,
      };
    }
    case GET_USER_FAVORITE_BENCHMARK_REPORTS_SUCCEEDED:
      return {
        ...state,
        favoriteBenchmarkReports: action.payload,
      };
    case GET_USER_METRICS:
      return {
        ...state,
        loadingMetrics: true,
      };
    case GET_USER_METRICS_SUCCEEDED: {
      return {
        ...state,
        userMetrics: action.payload,
        loadingMetrics: false,
      };
    }
    case CLEAR_HOME_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};

export default reducer;
